<template>
  <div>
    <!--       重置密码    -->
    <div>
      <el-form
        ref="formPass"
        :model="formPass"
        :rules="rules"
        label-position="left"
        label-width="0px"
        label-height="100px"
      >
        <el-form-item prop="oldpass">
          <el-input
            type="password"
            v-model="formPass.oldPass"
            auto-complete="off"
            :placeholder="$t('common.oldPass')"
          ></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            type="password"
            v-model="formPass.password"
            auto-complete="off"
            :placeholder="$t('common.newPass')"
          ></el-input>
        </el-form-item>
        <el-form-item prop="checkPass">
          <el-input
            type="password"
            v-model="formPass.checkPass"
            auto-complete="off"
            :placeholder="$t('common.enterNewAg')"
          ></el-input>
        </el-form-item>
        <el-button type="primary" size="mini" @click="submitFormPass">{{
          $t("common.trueText")
        }}</el-button>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("common.passwordAgain")));
      } else if (value !== this.formPass.password) {
        callback(new Error(this.$t("common.passIsNotSame")));
      } else {
        callback();
      }
    };
    return {
      formPass: {
        oldPass: "",
        password: "",
        checkPass: "",
      },
      rules: {
        mail: [
          {
            required: true,
            message: this.$t("common.NotNull"),
            trigger: "blur",
          },
          {
            pattern:
              /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/,
            message: " ",
            trigger: "blur",
          },
        ],
        mobile: [
          {
            required: true,
            message: this.$t("common.NotNull"),
            trigger: "blur",
          },
          {
            pattern: /^1[3456789]\d{9}$/,
            message: this.$t("msg.rightPhone"),
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: this.$t("common.enterpassword"),
            trigger: "blur",
          },
          {
            min: 6,
            max: 18,
            pattern: /^[A-Za-z0-9]{6,18}$/,
            message: this.$t("common.pleaseInputPass"),
            trigger: "blur",
          },
        ],
        checkPass: [
          { validator: validatePass, trigger: "blur", required: true },
        ],
        passcode: [
          {
            required: true,
            message: this.$t("common.pleaseInputVerificationCode"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    changeFunc(val) {
      if (val == "login") {
        let meetingCode = localStorage.getItem("meetingCode");
        this.$router.push({
          name: "login",
          query: { meetingCode: meetingCode },
        });
      }
    },
    submitFormPass() {
      this.$refs.formPass.validate((valid) => {
        if (valid) {
          let form = {
            password: this.formPass.oldPass,
            newPassword: this.formPass.password,
          };

          this.$api.modifyPassword(form).then((res) => {
            if (res.code === "200") {
              this.$message({
                message:
                  this.$i18n.locale == "en" && res.retMsgEn
                    ? "Success"
                    : "修改密码成功！",
                type: "success",
              });
              window.setTimeout(() => {
                if (this.$store.state.dict.currentMeetingCode) {
                  this.$router.push(
                    "/login/" + this.$store.state.dict.currentMeetingCode
                  );
                }
              }, 1000);
              //var token = res.datas.map.token;
            } else {
              if (this.$i18n.locale == "en" && res.retMsgEn) {
                this.$message({
                  message: res.retMsgEn,
                  type: "error",
                });
              } else {
                this.$message({
                  message: res.retMsg,
                  type: "error",
                });
              }
            }
          });
        }
      });
    },
  },
};
</script>

<style scoped>
</style>
